import { Spin } from 'antd';

const Loading: React.FC = () => {
    return (
        <div className="bg-[#ffffffc7] fixed top-0 left-0 bottom-0 right-0 z-50 flex justify-center items-center">
            <Spin size="large" />
        </div>
    );
};

export default Loading;
